import { useState } from "react";
import {
  Box,
  Typography,
  Chip,
  IconButton,
  CircularProgress,
  useTheme,
  alpha,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const ConnectionsList = ({ connections = [], onDelete }) => {
  const theme = useTheme();
  const [deletingId, setDeletingId] = useState(null);

  if (!connections.length) return null;

  const handleDelete = async (id) => {
    setDeletingId(id);
    try {
      await onDelete?.(id);
    } finally {
      setDeletingId(null);
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: "14px",
        p: 2.5,
        mb: 3,
      }}
    >
      <Typography sx={{ color: theme.palette.text.primary, fontWeight: 600, fontSize: "0.9rem", mb: 1.5 }}>
        Cuentas conectadas ({connections.length})
      </Typography>

      {connections.map((conn, idx) => (
        <Box
          key={conn.id}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            py: 1.2,
            borderTop: idx === 0 ? "none" : `1px solid ${theme.palette.divider}`,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0 }}>
            <Typography
              sx={{
                fontFamily: "'Courier New', monospace",
                fontSize: "0.82rem",
                color: theme.palette.text.primary,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {conn.client_id}
            </Typography>
            <Chip
              label={conn.connected ? "Conectado" : "Pendiente"}
              size="small"
              sx={{
                height: 22,
                fontSize: "0.68rem",
                fontWeight: 600,
                backgroundColor: conn.connected
                  ? alpha(theme.palette.success.main, 0.12)
                  : alpha(theme.palette.warning.main, 0.12),
                color: conn.connected ? theme.palette.success.dark : theme.palette.warning.dark,
              }}
            />
          </Box>
          <IconButton
            size="small"
            disabled={deletingId === conn.id}
            onClick={() => handleDelete(conn.id)}
            sx={{ color: theme.palette.error.main, ml: 1 }}
            aria-label="Eliminar conexión"
          >
            {deletingId === conn.id ? (
              <CircularProgress size={16} />
            ) : (
              <DeleteOutlineIcon sx={{ fontSize: 18 }} />
            )}
          </IconButton>
        </Box>
      ))}
    </Box>
  );
};

export default ConnectionsList;
